import { render, staticRenderFns } from "./FormLearningOutcome.vue?vue&type=template&id=1b9df2a8&"
import script from "./FormLearningOutcome.vue?vue&type=script&lang=js&"
export * from "./FormLearningOutcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports